import { mapActions, mapState } from 'vuex';
import { performLogout } from '@/Util/logout';
import { msg_code } from './msg_code';

export default {
  data() {
    return {
      intervalId: null,
    };
  },
  mounted() {
    this.startInterval();
    document.addEventListener('mousemove', this.resetInterval);
    document.addEventListener('keypress', this.resetInterval);
  },
  computed: {
    ...mapState(['userID', 'userEmail', 'token']),
  },
  methods: {
    ...mapActions(['logout', 'setSessionExpiredMessage']),
    startInterval() {
      this.intervalId = setInterval(() => {
        this.logoutAndRedirect();
      }, 60 * 60 * 1000);
    },
    resetInterval() {
      clearInterval(this.intervalId);
      this.startInterval();
    },
    logoutAndRedirect() {
      performLogout(this.userID, this.userEmail, this.token, this.logout, this.$router);
      this.setSessionExpiredMessage(msg_code("wf014"));
    }
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
    document.removeEventListener('mousemove', this.resetInterval);
    document.removeEventListener('keypress', this.resetInterval);
  },
};